import { FileMeta } from './file-meta.model';

export class FileMetaWithPayload {
  file: FileMeta;
  [x: string]: unknown;
}
